import AuthLayout from "layouts/AuthLayout";
import { VerifyEmailPage } from "pages/accounts-onboarding/verify-email";
import React from "react";

const VerifyEmailRoute = () => {
	return (
		<AuthLayout>
			<VerifyEmailPage />
		</AuthLayout>
	);
};

export default VerifyEmailRoute;
